import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchLibraryMessageTemplates } from "../api/messageTemplateService";
export var libraryMessageTemplatesKey = function (libraryId) { return [
    "library-message-templates",
    libraryId,
]; };
export var useLibraryMessageTemplates = function (libraryId, enabled) {
    var kyInstance = useOkapiKy();
    return useQuery(libraryMessageTemplatesKey(libraryId), function () { return fetchLibraryMessageTemplates(kyInstance, libraryId); }, 
    // the settings link can still be opened in a new tab; returning must refresh the warnings
    { enabled: enabled && !!libraryId, refetchOnWindowFocus: true });
};
